import { localTime } from '@helpers';
import { DATE_FORMAT } from '@v2/pages/common/constants/base.constants';
import { TimePeriod } from '@v2/pages/machines/common/enums';
import { BarDateRangeResult } from '@components/machines/components/eventsChart/types';
import { getEightWeeksWindow } from './period';

export const getBarDateRangeForPeriod = (selectedTime: string, selectedChartDate?: string): BarDateRangeResult | null => {
  let momentStart = localTime();
  let momentEnd = localTime();
  if (selectedChartDate) {
    momentStart = localTime(selectedChartDate);
    momentEnd = localTime(selectedChartDate);
  }

  switch (selectedTime) {
    case TimePeriod.DAY: {
      const start = momentStart.clone().startOf('day');
      const end = momentStart.clone().add(1, 'day').startOf('day');

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        amount: 24,
        period: 'hour',
        statsType: 'hour',
      };
    }
    case TimePeriod.WEEK: {
      const start = momentStart.clone().startOf('isoWeek');
      const end = momentEnd.clone().add(1, 'isoWeek').startOf('isoWeek');

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        amount: 7,
        period: 'day',
        statsType: 'day',
      };
    }
    case TimePeriod.MONTH: {
      const start = momentStart.clone().startOf('month');
      const end = momentEnd.clone().add(1, 'month').startOf('month');
      const amount = momentStart.daysInMonth();

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        amount,
        period: 'day',
        statsType: 'day',
      };
    }
    case TimePeriod.YEAR: {
      const start = momentStart.clone().startOf('year');
      const end = momentEnd.clone().add(1, 'year').startOf('year');

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        amount: 12,
        period: 'month',
        statsType: 'month',
      };
    }
    case TimePeriod.EIGHT_WEEKS: {
      const { start, end } = getEightWeeksWindow(momentStart);

      return {
        start: start.format(DATE_FORMAT),
        end: end.format(DATE_FORMAT),
        amount: 8,
        period: 'isoWeek',
        statsType: 'week',
      };
    }
    default:
      return null;
  }
};
